import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class SpinnerService {
  /**
   *
   * @type {BehaviorSubject<boolean>}
   */
  spinnerSource = new BehaviorSubject<boolean>(false);
  /**
   *
   * @type {BehaviorSubject<boolean>}
   */
  private autoSaveSource = new BehaviorSubject<boolean>(false);

  /**
   *
   * @type {Observable<boolean>}
   */
  spinner$ = this.spinnerSource.asObservable();

  /**
   *
   * @type {Observable<boolean>}
   */
  autoSave$ = this.autoSaveSource.asObservable();

  constructor() { }

  /**
   *
   * @param {boolean} hide
   */
  setSpinner(hide: boolean) {
      this.spinnerSource.next(hide);
  }

  /**
   *
   * @param {boolean} hide
   */
  setAutoSave(hide: boolean){
    if(!hide){
      setTimeout(()=>{ this.autoSaveSource.next(hide); }, 600);
    }else {
      this.autoSaveSource.next(hide);
    }

  }
}


// WEBPACK FOOTER //
// ./src/app/services/spinner.service.ts